export const FIND_EMPLOYEE_ROLE_REQUEST = 'FIND_EMPLOYEE_ROLE_REQUEST';

export const findEmployeeRoleRequest = ( id ) => ({
    type: FIND_EMPLOYEE_ROLE_REQUEST,
    payload: { id }
});
